<template>
  <Teleport to="body">
    <div ref="panel" class="offcanvas offcanvas-end contract-panel" tabindex="-1" :id="ModalName" :aria-labelledby="ModalName + '-title'">
      <div class="offcanvas-header contract-header">
        <div>
          <span class="contract-eyebrow">SÖZLEŞME</span>
          <h2 :id="ModalName + '-title'">{{ Title }}</h2>
          <p>Satın almadan önce sözleşme koşullarını inceleyebilirsin.</p>
        </div>
        <button type="button" class="btn-close" aria-label="Sözleşmeyi kapat" @click="CloseModal"></button>
      </div>
      <div class="offcanvas-body contract-body" :aria-busy="loading">
        <div v-if="loading" class="contract-state" role="status">
          <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <span>Sözleşme yükleniyor…</span>
        </div>
        <div v-else-if="loadError" class="contract-state" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          <p>Sözleşme şu anda yüklenemedi.</p>
          <button type="button" class="contract-retry" @click="loadContent">Tekrar dene</button>
        </div>
        <div v-else class="contract-document" v-html="RenderedContent"></div>
      </div>
      <div class="contract-footer">
        <p>Sözleşmeyi kabul etmek için ödeme ekranındaki kutuyu işaretle.</p>
        <button type="button" class="contract-return" @click="CloseModal"><i class="bi bi-arrow-left" aria-hidden="true"></i> Kapat ve ödemeye dön</button>
      </div>
    </div>
  </Teleport>
</template>
  <script>
import { mapActions } from "vuex";
import {DateFormat} from "@/common/datetime-helper";
import bootstrapBundle from 'bootstrap/dist/js/bootstrap.bundle';
  export default {
    name: "MarketSellingContractModal",
    emits: ["CloseModal"],
    props: {
      ContentKey: { type: String, default: 'DistanceSellingContrat' },
      ModalName:{
        type:String,
        default:'MarketSellingContractModal'
      },
      Visible:{
        type:Boolean,
        default:false
      },
      Title:{
        type:String,
        default:''
      },
      Form:{
        type:Object,
      },
    },
    data() {
      return {
        loading:false, loadError:false, requestId:0,
        contentHtml:'',
      };
    },
    computed: {
      RenderedContent() {
          let value = this.contentHtml;
          if (value != "" && this.ContentKey === 'DistanceSellingContrat') {
              value = value.replace(/%NAME%/g, this.Form.invoiceTitle);
              value = value.replace(/%SURNAME%/g, "");
              value = value.replace(/%ADDRESS%/g, this.Form.invoiceAddress);
              value = value.replace(/%PHONE%/g, this.Form.phoneNumber);
              value = value.replace(/%MAIL_ADDRESS%/g, this.Form.emailAddress);
              value = value.replace(/%PACKAGE_NAME%/g, this.Form.packageTitle);
              value = value.replace(/%AMOUNT%/g, this.Form.packageAmount);
              value = value.replace(/%INVOICE_ADDRESS%/g, this.Form.invoiceAddress);
              value = value.replace(/%PACKAGE_BEGIN_DATE%/g, DateFormat(this.Form.packageBeginDate,'dd.mm.yyyy'));
              value = value.replace(/%DATE_OF_CONTRACT%/g, DateFormat(this.Form.invoiceDate, 'dd.mm.yyyy'));
          }
          return value
      },
    },
    methods: {
      ...mapActions(["GetGeneralContent"]),
      async loadContent(){
        const requestId = ++this.requestId;
        this.loading = true;
        this.loadError = false;
        this.contentHtml = '';
        try {
          const res = await this.GetGeneralContent(this.ContentKey);
          if (requestId !== this.requestId) return;
          this.contentHtml = res?.contentHtml || '';
          this.loadError = !this.contentHtml.trim();
        } catch {
          if (requestId === this.requestId) this.loadError = true;
        } finally {
          if (requestId === this.requestId) this.loading = false;
        }
      },
      CloseModal(){
        this.panelInstance.hide();
      },
      onPanelHidden(){
        this.$emit("CloseModal", false);
        if (this.returnFocus?.isConnected) this.returnFocus.focus();
      },
      openPanel(){
        this.returnFocus = document.activeElement;
        this.contentHtml = '';
        this.loadContent();
        this.$refs.panel.querySelector('.contract-body').scrollTop = 0;
        this.panelInstance.show();
      },
    },
    watch: {
      ContentKey(){
        if (this.Visible && this.$refs.panel?.classList.contains('show')) {
          this.loadContent();
          this.$refs.panel.querySelector('.contract-body').scrollTop = 0;
        }
      },
      Visible(value){
        if (!this.panelInstance) return;
        if (value) this.openPanel();
        else this.panelInstance.hide();
      }
    },
    mounted() {
      this.panelInstance = new bootstrapBundle.Offcanvas(this.$refs.panel, { backdrop: true, keyboard: true, scroll: false });
      this.$refs.panel.addEventListener('hidden.bs.offcanvas', this.onPanelHidden);
      if (this.Visible) this.openPanel();
    },
    beforeUnmount() { this.requestId++;
      const panel = this.$refs.panel;
      const instance = this.panelInstance;
      panel.removeEventListener('hidden.bs.offcanvas', this.onPanelHidden);
      if (panel.classList.contains('show') || panel.classList.contains('showing')) {
        panel.addEventListener('hidden.bs.offcanvas', () => instance.dispose(), { once: true });
        instance.hide();
      } else {
        instance.dispose();
      }
    }
  };
</script>

<style scoped>
.contract-panel { --bs-offcanvas-width: 640px; max-width: 100%; color: #10243a; background: #fff; border-left: 1px solid #e0e6ed; }
.contract-header { align-items: flex-start; gap: 20px; padding: 28px 32px 24px; border-bottom: 1px solid #edf0f4; }
.contract-eyebrow { color: var(--brand-link); font-size: 10px; font-weight: 700; letter-spacing: 1.5px; }
.contract-header h2 { margin: 10px 0; font-size: 23px; font-weight: 700; letter-spacing: -.6px; }
.contract-header p { margin: 0; color: #637489; font-size: 13px; line-height: 1.7; }
.contract-header .btn-close { flex-shrink: 0; margin: 0; padding: 10px; }
.contract-body { padding: 28px 32px; overscroll-behavior: contain; }
.contract-document { color: #46576b; font-size: 14px; line-height: 1.85; overflow-wrap: anywhere; }
.contract-document :deep(table) { max-width: 100%; }
.contract-document :deep(img) { max-width: 100%; height: auto; }
.contract-document :deep(h1), .contract-document :deep(h2), .contract-document :deep(h3) { color: #10243a; font-size: 18px; line-height: 1.5; }
.contract-state { display: flex; flex-direction: column; align-items: center; gap: 14px; padding: 48px 12px; text-align: center; color: #637489; font-size: 14px; }
.contract-state p { margin: 0; }
.contract-state > i, .contract-state .spinner-border { color: var(--brand-link); }
.contract-footer { flex-shrink: 0; padding: 20px 32px max(24px, env(safe-area-inset-bottom)); border-top: 1px solid #edf0f4; background: #f7f9fb; }
.contract-footer p { margin: 0 0 14px; font-size: 12px; color: #637489; line-height: 1.6; }
.contract-return { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 14px 20px; background: var(--brand-link); color: white; border: 0; border-radius: 10px; font-size: 14px; font-weight: 600; }
.contract-return:hover { background: #06634d; }
.contract-retry { border: 1px solid #cce3d9; border-radius: 10px; padding: 10px 18px; background: #edf7f2; color: var(--brand-link); }
.contract-panel button:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
@media (max-width: 575px) { .contract-panel { --bs-offcanvas-width: 100vw; border: 0; } .contract-header { padding: 24px 20px 20px; } .contract-header h2 { font-size: 21px; } .contract-body { padding: 24px 20px; } .contract-footer { padding-left: 20px; padding-right: 20px; } }
@media (prefers-reduced-motion: reduce) { .contract-panel { transition: none; } }
</style>